<template>
    <div id="tax-factors">
        <step-title class="tax-factors-title" step-title="Tax Factors"></step-title>
        <text-field-with-symbol class="calc-input individual-income" id="individual-income" :value="individualGrossIncomeValue" v-on:calc="calcIndividualGrossIncomeValue" name="Individual-Gross-Income" label="Individual Gross Income p.a" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
        <div id="tax-rate-container" style="width: 85%; margin: 0 auto; margin-bottom: 45px; margin-top: -15px;"> <p id="tax-rate" class="extra-info" style="float: right; width: 170px; margin-left: auto; padding-right: 3px; color: #465978; font-size: 15px; text-align: right;">Tax Rate is {{ taxRateValue }}%</p></div>
        <sub-step-title class="estimated-first-year-depreciation-header" sub-step-title="Estimated First Year Depreciation" has-tooltip></sub-step-title>
        <div class="calc-col-one">
            <button-group-two :current-value="purchaseDateValue" v-on:calcOne="calcPurchaseDateValue" v-on:calcTwo="calcPurchaseDateValue" name="Property-Purchase-Date" label="Did you purchase this property prior to 9 May 2017?" button-one-text="No" button-two-text="Yes"></button-group-two>
            <button-group-two class="property-bought" :current-value="propertyBoughtValue" v-on:calcOne="calcPropertyBoughtValue" v-on:calcTwo="calcPropertyBoughtValue" name="Property-Bought" label="Property Bought" button-one-text="2nd Hand" button-two-text="Brand New" v-show="showPropertyBought"></button-group-two>
            <dropdown class="property-type" :selectedOption="propertyTypeValue" v-on:changeOption="calcPropertyTypeValue" name="Property-Type" label="Property Type" :options="propertyTypeOptions" has-tooltip></dropdown>
        </div>
        <div class="calc-col-two">
            <dropdown :selectedOption="nearestCapitalCityValue" v-on:changeOption="calcNearestCapitalCityValue" name="Nearest-Capital-City" label="Nearest Capital City" :options="nearestCapitalCityOptions" v-bind:has-tooltip="false"></dropdown>
            <dropdown class="construction-year" :selectedOption="constructionYearValue" v-on:changeOption="calcConstructionYearValue" name="Construction-Year" label="Construction Year" :options="constructionYearOptions" has-tooltip></dropdown>
            <button-group-three class="standard-of-finish" v-on:calcOne="calcStandardOfFinishValue" v-on:calcTwo="calcStandardOfFinishValue" v-on:calcThree="calcStandardOfFinishValue" name="Standard-of-Finish" label="Standard of Finish" button-one-text="Low" button-two-text="Medium" button-three-text="High" has-tooltip></button-group-three>
        </div>
        <p style="width: 85%; overflow: hidden; margin: 0 auto; margin-bottom: 30px; color: #465978; font-size: 12px; text-align: center" class="step3-link">Depreciation Calculator courtesy of <a href="https://www.washingtonbrown.com.au/depreciation/calculator/" target="_blank">Washington Brown Quantity Surveyors</a></p>
        <step-result-label class="estimated-depreciation-amount" result-label="Estimated Depreciation Amount" :step-result="estimatedAmountValue" :result-error="estimatedAmountErrorMessage"></step-result-label>
    </div>
</template>

<script>
    import StepTitle from './StepTitle';
    import SubStepTitle from './SubStepTitle';
    import TextFieldWithSymbol from './TextFieldWithSymbol';
    import ButtonGroupTwo from './ButtonGroupTwo';
    import ButtonGroupThree from './ButtonGroupThree';
    import Dropdown from './Dropdown';
    import StepResultLabel from './StepResultLabel';

    import axios from 'axios';

    export default {
        components: {
            StepTitle,
            SubStepTitle,
            TextFieldWithSymbol,
            ButtonGroupTwo,
            ButtonGroupThree,
            Dropdown,
            StepResultLabel
        },
        name: "tax-factors",
        data () {
          return {

          }
        },
        computed: {
            constructionYearOptions() {
                return this.$store.state.taxFactors.getConstructionYearOptions();
            },
            propertyTypeOptions() {
                return this.$store.state.taxFactors.getPropertyTypeOptions();
            },
            nearestCapitalCityOptions() {
                return this.$store.state.taxFactors.getNearestCapitalCityOptions();
            },
            individualGrossIncomeValue() {
                return this.$store.state.taxFactors.getIndividualGrossIncome();
            },
            taxRateValue() {
                return this.$store.state.taxFactors.getTaxRate();
            },
            propertyBoughtValue() {
                return this.$store.state.taxFactors.getPropertyBought();
            },
            propertyTypeValue() {
                return this.$store.state.taxFactors.getPropertyType();
            },
            purchaseDateValue() {
                return this.$store.state.taxFactors.getPurchaseDate();
            },
            constructionYearValue() {
                return this.$store.state.taxFactors.getConstructionYear();
            },
            nearestCapitalCityValue() {
                return this.$store.state.taxFactors.getNearestCapitalCity();
            },
            standardOfFinishValue() {
                return this.$store.state.taxFactors.getStandardOfFinish();
            },
            estimatedAmountValue() {
                return this.$store.state.taxFactors.getEstimatedAmount();
            },
            estimatedAmountErrorMessage () {

                if (!this.$store.state.taxFactors.getSuccessfullyCalculated()) {
                    return "No Results";
                }

                return '';
            },
            showPropertyBought() {
                return this.$store.state.taxFactors.getPurchaseDate() === 'No';
            }
        },
        methods: {
            calcIndividualGrossIncomeValue: function(individualGrossIncome) {
                this.$store.commit('individualGrossIncomeValueCalc', individualGrossIncome);
            },
            calcPropertyBoughtValue: function(propertyBought) {
                this.$store.commit('propertyBoughtValueCalc', propertyBought);
                this.calcEstimatedAmountValue();
            },
            calcPropertyTypeValue: function(propertyType) {
                this.$store.commit('propertyTypeValueCalc', propertyType);
                this.calcEstimatedAmountValue();
            },
            calcPurchaseDateValue: function(purchaseDate) {
                this.$store.commit('purchaseDateValueCalc', purchaseDate);
                this.calcEstimatedAmountValue();

                if (purchaseDate === 'Yes') {
                    this.showPropertyBought = false;
                } else if (purchaseDate === 'No') {
                    this.showPropertyBought = true;
                }
            },
            calcConstructionYearValue: function(constructionYear) {
                this.$store.commit('constructionYearValueCalc', constructionYear);
                this.calcEstimatedAmountValue();
            },
            calcNearestCapitalCityValue: function(nearestCapitalCity) {
                this.$store.commit('nearestCapitalCityValueCalc', nearestCapitalCity);
                this.calcEstimatedAmountValue();
            },
            calcStandardOfFinishValue: function(standardOfFinish) {
                this.$store.commit('standardOfFinishValueCalc', standardOfFinish);
                this.calcEstimatedAmountValue();
            },
            calcEstimatedAmountValue: function() {

                var propertyPrice = this.$store.state.purchaseCosts.getPurchasePrice();
                var city = this.$store.state.taxFactors.getNearestCapitalCity();
                city = city.toUpperCase();

                var buildingCategory = this.$store.state.taxFactors.getPropertyType();
                if (buildingCategory === 'House/Townhouse') {
                    buildingCategory = 'House'
                } else if (buildingCategory === 'Commercial Property') {
                    buildingCategory = 'Commercial Suite'
                } else if (buildingCategory === 'Industrial Property') {
                    buildingCategory = 'Industrial Suite'
                }

                var buildingQuality = this.$store.state.taxFactors.getStandardOfFinish();
                buildingQuality = buildingQuality.toUpperCase();
                var buildYear = this.$store.state.taxFactors.getConstructionYear();
                if (buildYear.toString().includes('< ')) {
                    buildYear = buildYear.toString().slice(2, buildYear.toString().length);
                }

                var purchaseDate = this.$store.state.taxFactors.getPurchaseDate();
                var propertyBought = this.$store.state.taxFactors.getPropertyBought();

                var budgetChange;
                if (purchaseDate === "Yes") {
                    budgetChange = 0;
                } else if (purchaseDate === "No" && propertyBought === '2nd Hand') {
                    budgetChange = 1;
                } else if (purchaseDate === "No" && propertyBought === 'Brand New') {
                    budgetChange = 2;
                }

                axios.get('https://cors.bridged.cc/https://portal.washingtonbrown.com.au/webservices/default.aspx?unm=kHhQt/' +
                    'dk4l+87aYxO0YoqWVdaLfDiapGmj+Q0L9Dmq8HIKOikWsUf4yN8tjwOr1Rz4E/' +
                    'wwvxsuXczoal7deYib3Ig3UMYP+3&ResultType=0', {
                    headers: {
                        'Origin': '*',
                        'Access-Control-Allow-Origin': '*'
                    },
                    params: {
                        PropertyPrice: propertyPrice,
                        City: city,
                        BuildingCategory: buildingCategory,
                        BuildingQuality: buildingQuality,
                        BuildYear: buildYear,
                        BudgetChange: budgetChange
                    }
                }).then(response => {
                    var data = response.data;

                    var estimatedAmountStartIndex = data.indexOf('<DV_YEAR_1>') + 11;
                    var estimatedAmountEndIndex = data.indexOf('</DV_YEAR_1>');

                    var estimatedAmount = Number(data.substring(estimatedAmountStartIndex, estimatedAmountEndIndex));
                    var successfullyCalculated = true;

                    if (isNaN(estimatedAmount)) {
                        estimatedAmount = 0;
                        successfullyCalculated = false;
                    }

                    this.$store.commit('estimatedAmountValueCalc', estimatedAmount);
                    this.$store.commit('successfullyCalculatedDepreciationAmount', successfullyCalculated);
                })
                    .catch(e => {

                    });
            }
        }
    }
</script>

<style scoped>

    #tax-factors {
        overflow: auto;
    }

    .estimated-first-year-depreciation-header {
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .extra-bottom-margin {
        margin-bottom: 30px !important;
    }

    .individual-income {
        margin-top: 30px !important;
    }

    #tax-rate {
        margin-top: 0;
    }

    @media (min-width: 1524px) {

        .calc-input {
            width: 55% !important;
        }

        #tax-rate {
            margin-right: -55px;
        }
    }

    @media not print {
        @media (min-width: 1024px) {

            .calc-input {
                width: 45%;
            }

            #tax-rate-container {
                width: 45% !important;
            }

            .calc-col-one {
                width: 50%;
                float: left;
            }

            .calc-col-two {
                width: 50%;
                float: right;
            }
        }
    }

    @media (max-width: 1023px) {
        .step3-link {
            margin-bottom: 15px !important;
        }
    }

    @media (max-width: 361px) {
        #tax-rate-container {
            margin-bottom: 65px !important;
        }
    }

    @media (max-width: 338px) {
        .extra-top-margin {
            margin-top: 120px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/Components/TaxFactors.vue